// ─── NEWS ────────────────────────────────────────────────────────────────────

export const NEWS_CATEGORIES = [
    'All', 'NEET Updates', 'Exam Alerts', 'Results', 'Counselling', 'Policy', 'Science & Medicine',
]

export interface NewsArticle {
    id: string
    title: string
    excerpt: string
    content: string
    category: string
    date: string
    readTime: string
    image: string
    featured: boolean
    tag: string
}

export const mockNews: NewsArticle[] = [
    {
        id: 'n1',
        title: 'NEET UG 2025 Official Exam Date Announced by NTA – Key Details',
        excerpt: 'The National Testing Agency (NTA) has officially announced the NEET UG 2025 exam date. Students are advised to check the official website for registration details and important deadlines.',
        content: `The National Testing Agency (NTA) has officially announced the NEET UG 2025 examination date, marking a crucial milestone for lakhs of medical aspirants across India.

**Key Highlights:**
- The exam will be conducted in a single shift across all examination centres
- Registration window opens this month on the official NTA NEET portal
- Students must carry valid ID proof and admit card on exam day
- Exam pattern remains same: 200 questions, 720 marks (180 attempted)

**Important Dates to Remember:**
1. Online Application Start Date – To be announced
2. Last Date of Registration – To be announced
3. Admit Card Release – Two weeks before exam
4. NEET UG 2025 Exam Date – Officially confirmed

**What Students Should Do Now:**
Begin your chapter-wise revision immediately. Focus on high-weightage topics in Biology (plant physiology, genetics, human physiology), Physics (mechanics, electrostatics, optics), and Chemistry (organic reactions, equilibrium, coordination chemistry).

Use mock tests regularly and simulate actual exam conditions. Time management is critical – practice completing 180 questions in 3 hours 20 minutes consistently.

Stay tuned to the official NTA website at nta.ac.in for all updates, corrections, and notifications.`,
        category: 'NEET Updates',
        date: '2025-03-15',
        readTime: '3 min read',
        image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b6f5d?w=1200&h=600&fit=crop',
        featured: true,
        tag: 'Breaking',
    },
    {
        id: 'n2',
        title: 'NEET 2025 Syllabus Revised: Physics Section Gets Major Overhaul',
        excerpt: 'NTA has released the revised NEET 2025 syllabus with significant changes to the Physics section. Experts predict this will impact preparation strategies for lakhs of aspirants.',
        content: `The National Testing Agency has released a revised syllabus for NEET UG 2025, with the Physics section undergoing the most significant restructuring in recent years.

**What Changed in Physics:**
Several chapters from Class 11 and 12 Physics have been reorganised. The new syllabus places increased emphasis on:
- Modern Physics (Dual Nature, Atoms & Nuclei)
- Semiconductor Electronics
- Electromagnetic Waves and Communication Systems

**Topics with Reduced Weightage:**
- Some thermodynamics sub-topics
- Certain optics concepts

**Biology Remains Largely Unchanged:**
The Biology section continues to follow the NCERT framework closely. Students are advised to cover all NCERT lines without skipping any topic.

**Chemistry Updates:**
Minor updates in Organic Chemistry to align with updated NCERT editions. Coordination compounds and d-block elements remain high-priority.

**Expert Advice:**
"Students who have already begun preparation should not panic. The core concepts remain the same. Adjust your study plan to give slightly more time to the updated Physics chapters," said a senior faculty member at Future Founder.

Download the official revised syllabus from nta.ac.in and compare it with your current study plan immediately.`,
        category: 'NEET Updates',
        date: '2025-03-10',
        readTime: '5 min read',
        image: 'https://images.unsplash.com/photo-1532094349884-543559c7d517?w=1200&h=600&fit=crop',
        featured: false,
        tag: 'Important',
    },
    {
        id: 'n3',
        title: 'Supreme Court Upholds NMC Regulations for Foreign Medical Graduates',
        excerpt: "In a landmark ruling, the Supreme Court has upheld the National Medical Commission regulations for Indian students pursuing MBBS abroad. Here's what it means for aspirants.",
        content: `In a landmark judgment, the Supreme Court of India has upheld the National Medical Commission (NMC) regulations governing Indian students who pursue MBBS degrees abroad.

**The Core Ruling:**
The court confirmed that Indian students who complete their MBBS from foreign universities must:
1. Pass the Foreign Medical Graduate Examination (FMGE) / NExT Exam to practice in India
2. Ensure their chosen university is listed on the NMC's approved list
3. Complete the required clinical training hours in NMC-recognised hospitals

**Impact on Students Considering Foreign MBBS:**
This ruling reinforces the importance of choosing NMC-approved universities. Students planning to study MBBS in Russia, Kazakhstan, China, or other countries must verify the approval status of their target university before applying.

**What Does This Mean Practically?**
- The NExT (National Exit Test) will now serve as the gateway for all graduates, domestic and foreign
- Passing rate for foreign medical graduates in FMGE has historically been around 15-20%
- Students must prepare rigorously for NExT from Day 1 of their MBBS abroad

**Future Founder's Counselling Team Says:**
"This ruling strengthens our recommendation to students: choose wisely. We help students identify the top NMC-approved universities with strong track records for NExT preparation support."

Contact our counselling team to get a list of currently approved universities and guidance on your application.`,
        category: 'Policy',
        date: '2025-03-08',
        readTime: '4 min read',
        image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1200&h=600&fit=crop',
        featured: false,
        tag: 'Legal',
    },
    {
        id: 'n4',
        title: 'NEET PG 2025 Results Declared – Check Scorecard & Cut-off Marks',
        excerpt: 'NEET PG 2025 results have been officially declared. Candidates can now check their scorecard and state-wise cut-off marks on the official NTA portal.',
        content: `NEET PG 2025 results have been officially declared by the National Board of Examinations (NBE). Candidates who appeared for the examination can now check their results on the official portal.

**How to Check Your Result:**
1. Visit natboard.edu.in
2. Click on "NEET PG 2025 Result"
3. Enter your Roll Number and Date of Birth
4. Download and save your scorecard

**Cut-off Marks (General Category):**
The cut-off for the General category has been set slightly higher than last year, reflecting the competitive nature of the examination this cycle.

**What's Next – Counselling Process:**
Qualified candidates will be eligible to participate in the NEET PG 2025 counselling conducted by the Medical Counselling Committee (MCC) for AIQ seats and respective state counselling bodies for state quota seats.

**Important for NEET UG Aspirants:**
Seeing NEET PG results is a reminder of the long journey ahead. Every NEET UG topper today was once an aspirant like you. Stay focused, stay consistent.

Our mentors at Future Founder are available for one-on-one counselling sessions to help you chart the right path.`,
        category: 'Results',
        date: '2025-03-05',
        readTime: '2 min read',
        image: 'https://images.unsplash.com/photo-1584697964358-3e14ca57658b?w=1200&h=600&fit=crop',
        featured: false,
        tag: 'Results',
    },
    {
        id: 'n5',
        title: 'All India MBBS Counselling 2025 Begins: Step-by-Step Guide',
        excerpt: 'The Medical Counselling Committee (MCC) has started the All India MBBS counselling for 2025. Here is a comprehensive guide to registering and choosing the right college.',
        content: `The Medical Counselling Committee (MCC) has officially commenced the All India Quota (AIQ) MBBS counselling process for NEET UG 2025 qualifiers.

**Step-by-Step Registration Process:**

**Step 1: Registration**
Visit mcc.nic.in and complete the online registration. Keep your NEET scorecard, Class 10 and 12 mark sheets, ID proof, and passport-size photo ready.

**Step 2: Choice Filling**
This is the most critical step. Research colleges thoroughly based on:
- Your NEET rank
- Previous year's closing ranks (available on MCC website)
- College reputation and clinical exposure
- Hostel and infrastructure facilities
- Location and cost of living

**Step 3: Seat Allotment**
MCC will allocate seats based on your rank, preferences, and seat availability. Multiple rounds will be conducted.

**Step 4: Reporting**
Once allotted, report to the college within the specified timeline with all original documents.

**Pro Tips from Our Counsellors:**
- Fill as many choices as possible – don't limit yourself
- Don't leave blank spaces in your choice list
- Research state quota and management quota options alongside AIQ
- Consider deemed universities if your rank allows

Need personalised guidance? Book a counselling session with our expert team.`,
        category: 'Counselling',
        date: '2025-03-02',
        readTime: '6 min read',
        image: 'https://images.unsplash.com/photo-1674027444485-cec3da58eef4?w=1200&h=600&fit=crop',
        featured: false,
        tag: 'Guide',
    },
    {
        id: 'n6',
        title: 'New Medical Colleges Approved by NMC for 2025 Academic Year',
        excerpt: 'The National Medical Commission has approved 25 new medical colleges across 12 states, adding approximately 3,200 MBBS seats for the 2025 academic year.',
        content: `The National Medical Commission (NMC) has given its approval to 25 new medical colleges across 12 Indian states for the 2025-26 academic year, adding approximately 3,200 new MBBS seats to the national pool.

**States Getting New Colleges:**
The new approvals are spread across Uttar Pradesh, Maharashtra, Rajasthan, Tamil Nadu, Telangana, Karnataka, Madhya Pradesh, Gujarat, Bihar, West Bengal, Odisha, and Andhra Pradesh.

**What This Means for NEET Aspirants:**
More seats mean slightly reduced competition for government and state quota colleges. However, NMC-approved private colleges still require significant NEET scores, typically in the range of 400-550+ for admissions.

**Quality Assurance:**
NMC has stated that all new colleges have been inspected for infrastructure, faculty strength, hospital beds, and clinical training facilities before approval.

**Advice for 2025 Aspirants:**
With new seats available, aspirants who may have missed government college cutoffs in previous years could find opportunities this cycle. Counsellors recommend researching newly approved colleges carefully and visiting for a campus tour if possible.

Our counselling team has updated its college database with all newly approved institutions.`,
        category: 'Policy',
        date: '2025-02-28',
        readTime: '3 min read',
        image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=1200&h=600&fit=crop',
        featured: false,
        tag: 'New',
    },
    {
        id: 'n7',
        title: 'Russia Medical Universities Update NMC Compliance Status for Indian Students',
        excerpt: 'Several top Russian medical universities have updated their NMC compliance status. Find out which universities are now fully approved for Indian students planning to study MBBS abroad.',
        content: `Several prominent Russian medical universities have formally updated their compliance documentation with the National Medical Commission (NMC) of India, clearing the path for Indian students to enrol with confidence.

**Key Universities with Updated Status:**
- Kazan Federal University – Fully Approved
- Sechenov University (Moscow) – Fully Approved
- Peoples' Friendship University of Russia – Approved
- Saint Petersburg State University – Updated Compliance

**Why This Matters:**
Indian students completing MBBS abroad must ensure their university appears on the current NMC-approved list. Without this, they cannot appear for the NExT Examination and cannot practice medicine in India.

**Points to Verify Before Enrolling:**
1. University must be on the current NMC approved list (updated annually)
2. University must offer MBBS in English medium
3. Clinical training must include India internship or NMC-recognised hospital hours
4. University should have a strong track record of Indian students passing NExT

**Future Founder's Abroad Counselling Service:**
We maintain an updated database of all NMC-approved foreign universities. Our counsellors provide end-to-end support — from university selection to visa assistance and post-admission NExT preparation planning.

Contact us today to schedule a free counselling session.`,
        category: 'NEET Updates',
        date: '2025-02-24',
        readTime: '4 min read',
        image: 'https://images.unsplash.com/photo-1562774053-701939374585?w=1200&h=600&fit=crop',
        featured: false,
        tag: 'International',
    },
    {
        id: 'n8',
        title: 'Ministry of Health Launches New Digital Awareness Campaign for NEET Aspirants',
        excerpt: 'The Ministry of Health and Family Welfare has launched a new pan-India digital awareness campaign to guide NEET aspirants through registration, preparation, and counselling.',
        content: `The Ministry of Health and Family Welfare, in collaboration with NTA, has launched a nationwide digital awareness campaign titled "Know Your NEET" to guide aspirants through every stage of the examination process.

**Campaign Coverage:**
The initiative covers:
- How to register for NEET UG correctly
- Understanding the exam pattern and syllabus
- How to access free study resources
- Understanding the counselling process
- Mental health support for aspirants

**Multi-Platform Reach:**
The campaign is being run across social media (YouTube, Instagram, Facebook), WhatsApp broadcast groups, school and college digital boards, and doordarshan.

**Free Resources Being Made Available:**
- Previous year question banks (downloadable PDF)
- Chapter-wise important questions
- NEET biology diagrams guide
- Time table templates for 6-month and 12-month preparation

**Future Founder's Take:**
"Government initiatives like these are crucial for first-generation college students and aspirants in rural areas who lack access to premium coaching. At Future Founder, we complement these efforts with personalised mentorship and doubt-clearing sessions."

Visit our website to access our own free NEET prep starter kit — no cost, no commitment.`,
        category: 'Policy',
        date: '2025-02-20',
        readTime: '2 min read',
        image: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=600&fit=crop',
        featured: false,
        tag: 'Government',
    },
]

// ─── BLOGS ───────────────────────────────────────────────────────────────────

export const BLOG_CATEGORIES = [
    'All', 'NEET Strategy', 'Biology Tips', 'Physics & Chemistry', 'Foreign MBBS', 'Student Life', 'Success Stories', 'Study Hacks',
]

export const BLOG_TAGS = [
    'NEET 2025', 'Biology', 'Physics', 'Chemistry', 'Study Plan', 'Time Management', 'Mock Tests', 'Motivation', 'Foreign MBBS', 'Coaching', 'Ranker Tips',
]

export interface BlogPost {
    id: string
    title: string
    excerpt: string
    content: string
    category: string
    author: string
    authorRole: string
    date: string
    readTime: string
    image: string
    tags: string[]
    featured: boolean
    views: string
}

export const mockBlogs: BlogPost[] = [
    {
        id: 'b1',
        title: 'How I Scored 700+ in NEET: A Complete Strategy Breakdown',
        excerpt: "In this post, I'll share exactly how I prepared for 12 months, the resources I used, my daily study schedule, and the mindset shifts that made all the difference. Spoiler: consistency beats intensity.",
        content: `Scoring 700+ in NEET is considered the holy grail for medical aspirants. I achieved it with AIR 245 in NEET 2024, and in this post, I'm going to share every detail of my preparation journey — no filters, no sugar-coating.

**My Starting Point**
In Class 11, I was scoring around 380-400 in mock tests. I was inconsistent, studying some days for 10 hours and then burning out the next 3 days. The turning point came when I joined Future Founder and got assigned a personal mentor.

**The 12-Month Strategy**
- **Months 1-4:** Foundation building. NCERT line by line, no shortcuts. Completed all NCERT chapters twice with highlighting.
- **Months 5-8:** Concept deepening. Used HC Verma for Physics, MS Chauhan for Organic Chemistry. For Biology, made self-notes from NCERT.
- **Months 9-11:** Mock test mode. Solved 1 full-length mock test every 3 days. After each test, spent 2 days analysing wrong answers.
- **Month 12:** Revision only. No new topics. Revised notes, diagrams, and weak chapters.

**Daily Schedule (Months 5–11)**
- 6:00 AM – Wake up, light exercise, meditation
- 7:00–9:00 AM – Biology (2 chapters)
- 9:30–11:30 AM – Physics (numerical practice)
- 12:00–1:00 PM – Lunch + break
- 2:00–4:00 PM – Chemistry (organic + inorganic alternated)
- 4:30–5:30 PM – Mentor doubt-clearing session (3x per week)
- 6:00–8:00 PM – Revision of the day's topics
- 9:00 PM – Light reading, sleep by 10:30 PM

**The Mindset Shifts That Changed Everything**
1. Stop comparing your Day 200 to someone else's Day 400
2. Consistency > Intensity. 6 focused hours beats 12 distracted ones
3. Mock test analysis IS study. Don't skip it
4. Sleep and nutrition are preparation too

**What I Would Do Differently**
Start mock tests earlier. I delayed full-length mocks until Month 6 out of fear. Starting them from Month 4 would have helped me build exam temperament faster.

If you're on this journey, trust your process. The 700+ scoreboard has students from every background, every city, every type of coaching. What they share is relentless consistency.

All the best — the stethoscope is closer than you think.`,
        category: 'Success Stories',
        author: 'Dr. Priya Sharma',
        authorRole: 'NEET 2024 Topper · AIR 245',
        date: '2025-03-18',
        readTime: '10 min read',
        image: 'https://images.unsplash.com/photo-1513258496099-48168024aec0?w=1200&h=600&fit=crop',
        tags: ['NEET 2025', 'Study Plan', 'Ranker Tips'],
        featured: true,
        views: '12.4k',
    },
    {
        id: 'b2',
        title: 'The Ultimate NEET Biology Syllabus Coverage Guide for 2025',
        excerpt: "Biology carries 360 marks in NEET. Here's a chapter-by-chapter priority breakdown with high-yield topics, expected weightage, and expert tips to maximize your score in both Botany and Zoology.",
        content: `Biology is your best friend in NEET. With 90 questions worth 360 marks, a strong Biology score can compensate for Physics struggles and keep your overall rank competitive. Here's how to maximise it.

**Chapter-wise Priority (Botany)**

🔴 **Very High Priority (5+ questions expected)**
- Plant Kingdom – Alternation of generations, life cycles
- Anatomy of Flowering Plants – All diagrams, tissue types
- Plant Physiology – Photosynthesis, respiration, transport
- Reproduction in Flowering Plants – Double fertilisation, embryo development
- Genetics – Mendel's laws, codominance, linkage

🟡 **High Priority (2-4 questions)**
- Morphology of Flowering Plants
- Cell Biology – Cell cycle, mitosis, meiosis
- Molecular Basis of Inheritance – Replication, transcription, translation
- Biotechnology and its Applications

🟢 **Moderate Priority (1-2 questions)**
- Biodiversity and Conservation
- Ecosystem
- Environmental Issues

**Chapter-wise Priority (Zoology)**

🔴 **Very High Priority**
- Human Physiology – Each system (5-6 questions expected)
- Structural Organisation in Animals
- Genetics and Evolution
- Reproductive Health

🟡 **High Priority**
- Animal Kingdom
- Human Reproduction
- Origin and Evolution of Life

**The NCERT Bible Rule**
Every single diagram, table, and example in NCERT is exam material. Don't summarise — read every line. For Biology, even the footnotes can yield 1 mark.

**Must-Do Practice**
- All previous 10 years' NEET Biology questions chapter-wise
- At least 50 MCQs per chapter from standard question banks
- Diagram labelling practice (especially plant anatomy, heart, nephron, brain)

**Expert Tip from Our Biology Mentor, Dr. Meera Nair:**
"Students consistently lose marks in Plant Physiology not because they don't know the concepts, but because they confuse numerical values – like CO₂ concentration for stomatal opening or the wavelength ranges for light reactions. Make a dedicated numerical fact sheet and revise it weekly."`,
        category: 'Biology Tips',
        author: 'Dr. Meera Nair',
        authorRole: 'Biology Mentor · Future Founder',
        date: '2025-03-14',
        readTime: '8 min read',
        image: 'https://images.unsplash.com/photo-1530026405186-ed1f139313f8?w=1200&h=600&fit=crop',
        tags: ['Biology', 'NEET 2025', 'Ranker Tips'],
        featured: false,
        views: '8.9k',
    },
    {
        id: 'b3',
        title: 'MBBS Abroad or India: A Brutally Honest 2025 Comparison',
        excerpt: 'Should you go to Russia, Kazakhstan, or Bangladesh for MBBS, or score higher in NEET for an Indian government seat? We break down costs, risks, career outcomes, and the NMC screening exam reality.',
        content: `This is a question our counsellors get every single day: "Should I go abroad for MBBS or keep trying for India?" Here's an honest, data-backed breakdown.

**The Indian Government College Dream**
A government MBBS seat in India costs approximately ₹25,000–₹1.5 Lakhs/year in fees. With hostel and living expenses, total cost over 5.5 years is typically ₹8–15 Lakhs. The training quality, clinical exposure, and brand value of AIIMS, JIPMER, or top state medical colleges is unmatched.

**The reality check:** Only ~90,000 seats exist in government colleges. With 20+ lakh NEET takers, you need a rank in the top 0.5% to get a premier government seat.

**Private MBBS in India**
Private college seats can cost anywhere from ₹50 Lakhs to ₹1.5 Crore for the full course. The return on investment depends heavily on the college's reputation and placement outcomes.

**Foreign MBBS – The Reality**

**Costs (Example: Russia)**
- Tuition: ₹3–5 Lakhs/year
- Hostel + Living: ₹2–3 Lakhs/year
- Total 6 years: ₹30–50 Lakhs (varies significantly)

**The NExT Barrier**
This is the most critical factor. To practice medicine in India after completing MBBS abroad, you must pass the National Exit Test (NExT). The pass rate for foreign medical graduates has historically been around 15-20%.

**Why Does It Matter?**
Many students go abroad dreaming of returning to practice in India, but the NExT remains a significant barrier. You must prepare for NExT from Day 1 of your MBBS abroad — treating it like a parallel exam track.

**When Foreign MBBS Makes Sense:**
- Your NEET rank doesn't qualify for any government or reasonably-priced private seat
- You're willing to put in serious effort for NExT preparation throughout your MBBS
- You choose an NMC-approved university with a strong track record
- You have a clear financial plan for the 6-year duration

**Our Honest Advice:**
Foreign MBBS is not a backdoor to becoming a doctor in India — it's a legitimate but challenging path. Choose it with open eyes, not desperation.

Book a free counselling session with our team to discuss your specific NEET rank, financial situation, and career goals.`,
        category: 'Foreign MBBS',
        author: 'Arjun Reddy',
        authorRole: 'Education Counsellor · Future Founder',
        date: '2025-03-11',
        readTime: '12 min read',
        image: 'https://images.unsplash.com/photo-1562774053-701939374585?w=1200&h=600&fit=crop',
        tags: ['Foreign MBBS', 'Coaching'],
        featured: false,
        views: '15.2k',
    },
    {
        id: 'b4',
        title: 'Physics Crash Course: Master These 10 Topics Before NEET 2025',
        excerpt: 'From Electrostatics to Modern Physics, these 10 chapters alone account for nearly 45% of Physics marks in NEET. Our expert mentor breaks down each topic with key formulas and solved examples.',
        content: `Physics is the bane of most NEET aspirants. But here's the secret most coaching institutes won't tell you: only 10 chapters consistently contribute the bulk of Physics marks in NEET. Master these, and Physics stops being your weakness.

**The Top 10 Physics Chapters for NEET 2025**

**1. Electrostatics & Capacitors (5-6 questions)**
Key: Coulomb's law, electric field due to various charge distributions, potential, capacitor combinations, energy stored.
Formula to memorise: E = kq/r², V = kq/r, U = ½CV²

**2. Current Electricity (4-5 questions)**
Key: Ohm's law, Kirchhoff's laws, Wheatstone bridge, meter bridge. Practice circuit diagrams daily.

**3. Magnetic Effects of Current (4-5 questions)**
Key: Biot-Savart law, Ampere's law, force on current-carrying conductors, galvanometer conversions.

**4. Electromagnetic Induction & AC (3-4 questions)**
Key: Faraday's laws, Lenz's law, self & mutual inductance, AC circuit analysis (LCR circuits).

**5. Ray Optics (3-4 questions)**
Key: Mirror formula, lens formula, refraction through prism, optical instruments. Draw ray diagrams for every problem.

**6. Modern Physics (Dual Nature + Atoms + Nuclei) (4-5 questions)**
Key: Photoelectric effect (Einstein's equation), de Broglie wavelength, Bohr model, radioactive decay, nuclear reactions.

**7. Laws of Motion & Work, Energy, Power (3-4 questions)**
Key: Newton's laws applications, friction problems, work-energy theorem, conservation of momentum.

**8. Rotational Motion (2-3 questions)**
Key: Moment of inertia (standard bodies), torque, conservation of angular momentum, rolling motion.

**9. Thermodynamics (2-3 questions)**
Key: Laws of thermodynamics, PV diagrams, Carnot engine efficiency, Cp, Cv relationships.

**10. Semiconductors (2-3 questions)**
Key: p-n junction, diode (forward/reverse bias), transistor basics, logic gates.

**Study Strategy:**
- Spend no more than 3-4 days per chapter in the final phase
- Focus on NCERT examples + previous year questions (last 5 years minimum)
- Don't get lost in derivations — focus on application
- Practice dimensional analysis to check formula correctness

"Physics in NEET tests conceptual clarity, not complex mathematics. If you understand the concept visually, the formulas follow naturally." — Prof. Anita Sharma, Physics Head, Future Founder`,
        category: 'Physics & Chemistry',
        author: 'Prof. Anita Sharma',
        authorRole: 'Physics Head · Future Founder',
        date: '2025-03-07',
        readTime: '7 min read',
        image: 'https://images.unsplash.com/photo-1636466497217-26a8cbeaf0aa?w=1200&h=600&fit=crop',
        tags: ['Physics', 'Study Plan', 'NEET 2025'],
        featured: false,
        views: '7.1k',
    },
    {
        id: 'b5',
        title: '30-Day NEET Revision Plan: The Science of Spaced Repetition',
        excerpt: "A month before NEET is not the time to learn new topics — it's the time to consolidate. This evidence-backed 30-day plan uses spaced repetition and active recall to retain everything you've studied.",
        content: `The 30 days before NEET are the most psychologically intense. Students either make the most of this golden window or lose marks they had already earned. Here's how to use it right.

**The Core Principle: Spaced Repetition**
Spaced repetition is a scientifically proven technique where you review material at increasing intervals. Instead of re-reading everything every day, you space out your reviews optimally:
- Day 1: Learn topic
- Day 3: First review
- Day 7: Second review
- Day 15: Third review
- Day 30: Final review before exam

**The 30-Day Plan**

**Week 1 (Days 1-7): Biology Blitz**
- Cover all 38 Biology chapters, 5-6 per day
- Only use your self-notes and NCERT diagrams
- Do 30 rapid-fire MCQs per chapter from previous year papers
- Goal: Identify which chapters need more attention

**Week 2 (Days 8-14): Chemistry + Physics**
- Days 8-10: Organic Chemistry — reaction mechanisms, named reactions
- Days 11-12: Physical Chemistry — numericals, equations
- Days 13-14: Physics — formula sheet revision + 20 numericals per chapter

**Week 3 (Days 15-21): Full Mock Tests**
- Take 1 full mock test every day or every alternate day
- Spend at least 2 hours post-test on analysis
- Note all error patterns in a "mistake diary"

**Week 4 (Days 22-28): Weak Area Targeting**
- Use your mistake diary to identify your top 5 weak areas
- Spend 1.5 days intensively on each weak area
- Do targeted 50-question MCQ sessions

**Days 29-30: Consolidation**
- No new topics, no new mock tests
- Light revision of formula sheets, diagrams, high-yield Biology facts
- Sleep 8 hours both nights, eat well, calm your mind

**The Most Important Rule:**
Do NOT start new topics in the last 30 days. You are not building the house — you are painting and finishing it. New topics at this stage will disrupt your existing knowledge structure without adding meaningful marks.`,
        category: 'NEET Strategy',
        author: 'Rahul Verma',
        authorRole: 'Academic Director · Future Founder',
        date: '2025-03-03',
        readTime: '6 min read',
        image: 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=1200&h=600&fit=crop',
        tags: ['Study Plan', 'Time Management', 'Mock Tests'],
        featured: false,
        views: '10.3k',
    },
    {
        id: 'b6',
        title: 'Managing Mental Health During NEET Preparation: A Real Talk',
        excerpt: 'Burnout, anxiety, and comparison can ruin even the most talented aspirant. In this post, we address the mental health challenges NEET students face and provide practical coping strategies.',
        content: `Let's have the conversation nobody wants to have: the mental health reality of NEET preparation. I've worked with hundreds of students over the years, and what breaks them isn't always lack of knowledge — it's the mental load.

**The Common Struggles**

**1. Comparison Paralysis**
"My classmate finished 5 chapters today. I only did 2. I'm so behind."
This is the most destructive thought pattern in NEET preparation. Everyone's journey is different. Your comparison baseline should be yesterday's you, not anyone else.

**2. Burnout Cycles**
Studying 12-14 hours a day sounds impressive until you crash and can't study at all for a week. Science supports 6-8 hours of focused, high-quality study over marathon sessions.

**3. Exam Anxiety**
The fear of failure — disappointing parents, losing a year, not achieving the dream — is real and heavy. Unaddressed, it becomes a performance barrier.

**4. Social Isolation**
Missing events, limiting social interaction, and withdrawing from relationships can lead to emotional depletion.

**Practical Coping Strategies**

**Daily Non-Negotiables:**
- 30 minutes of physical activity (walk, yoga, anything)
- 7-8 hours of sleep (non-negotiable — memory consolidation happens during sleep)
- At least one real conversation with a friend or family member
- 10 minutes of journaling or reflection

**For Anxiety:**
- 4-7-8 breathing technique (inhale 4s, hold 7s, exhale 8s)
- Identify your triggers and plan around them
- Talk to a mentor or counsellor

**For Burnout Prevention:**
- Plan weekly off time (even 4 hours on Sunday)
- Reward yourself for consistency, not just results
- Celebrate small wins — finishing a chapter, improving a mock test score

**When to Seek Help:**
If you experience persistent sadness, inability to focus for more than a few days, loss of appetite, or serious anxiety, please talk to a professional. NEET is important, but your mental health is more important.

At Future Founder, we include mental wellness support as part of our mentorship program. Your mentor is not just an academic guide — they're in your corner.`,
        category: 'Student Life',
        author: 'Dr. Kavya Iyer',
        authorRole: 'Student Wellness · Future Founder',
        date: '2025-02-27',
        readTime: '5 min read',
        image: 'https://images.unsplash.com/photo-1447452001602-7090c7ab2db3?w=1200&h=600&fit=crop',
        tags: ['Motivation', 'Study Plan'],
        featured: false,
        views: '6.5k',
    },
    {
        id: 'b7',
        title: 'How to Analyze NEET Mock Tests: Go Beyond the Score',
        excerpt: "Most students check their mock test score and move on. That's a mistake. Here's how to do a deep-dive analysis of every mock test to identify your weak zones and improve systematically.",
        content: `Here's what most NEET aspirants do after a mock test: check the score, feel good or bad about it, and move on. Here's what toppers do: spend more time on analysis than they spent on the test itself.

**Why Analysis > Solving More Tests**
Every wrong answer is a data point. It tells you exactly where your preparation has gaps. Without systematic analysis, you keep making the same mistakes across multiple tests — which means the same lost marks on exam day.

**The 5-Step Mock Test Analysis Framework**

**Step 1: Categorise Every Wrong Answer**
For each wrong answer, identify WHY you got it wrong:
- Type A: I didn't know this topic at all
- Type B: I knew the concept but made a calculation error
- Type C: I misread the question
- Type D: I second-guessed myself (changed right answer to wrong)
- Type E: I ran out of time

Different error types need different fixes.

**Step 2: Build Your Error Log**
Keep a dedicated notebook or spreadsheet. For each wrong answer, write:
- Chapter name and topic
- Error type (A/B/C/D/E)
- The correct concept/formula
- A note on how to avoid the same mistake

**Step 3: Track Patterns Over Time**
After 5 mock tests, look at your error log. You'll notice patterns:
- "I keep getting Plant Physiology numericals wrong" (Type A — need to revise)
- "I misread questions in Physics" (Type C — need to slow down and read carefully)
- "I change correct answers in Chemistry" (Type D — stop second-guessing after 20 seconds)

**Step 4: Fix Root Causes, Not Symptoms**
Type A errors → Revise the chapter + solve 50 targeted MCQs
Type B errors → Focus on calculation practice, dimensional analysis
Type C errors → Practice underlining key words in questions
Type D errors → Trust your first instinct after 15-20 seconds
Type E errors → Time management drill — practice 3 questions per 4 minutes

**Step 5: Track Your Score Improvement**
Keep a score tracker. Plot your mock test scores over time. The trend matters more than any single score. A consistent upward trend means your preparation is working.

**The Meta-Skill:**
Mock test analysis is the most transferable skill in NEET preparation. Students who master self-diagnosis improve far faster than those who just solve more tests.

Start your error log today. Even if your next test is months away.`,
        category: 'Study Hacks',
        author: 'Anil Verma',
        authorRole: 'Test Strategy Expert · Future Founder',
        date: '2025-02-22',
        readTime: '5 min read',
        image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b6f5d?w=1200&h=600&fit=crop',
        tags: ['Mock Tests', 'NEET 2025', 'Study Plan'],
        featured: false,
        views: '5.8k',
    },
    {
        id: 'b8',
        title: 'Organic Chemistry for NEET: A Visual Learning Approach',
        excerpt: "Organic Chemistry reactions can be daunting, but with the right visual memory techniques, you can retain 90% of the reaction mechanisms. Here's the approach our top students swear by.",
        content: `Organic Chemistry has a reputation for being the most difficult section of NEET Chemistry. But here's the truth our top students have discovered: it's actually the most learnable — if you use visual memory techniques.

**Why Traditional Methods Fail**
Most students try to memorise organic reactions as isolated facts. "Aldehyde + HCN gives → cyanohydrin." With 50+ reactions to remember, this approach causes confusion and forgetting.

**The Visual Story Method**
Instead of memorising reactions, create a visual "story" for each reaction mechanism. Think of the atoms as characters in a story.

Example — Aldol Condensation:
Instead of "an enolate attacks a carbonyl", visualise two molecules of acetaldehyde dancing, with the hydrogen leaving one molecule and attaching to the oxygen of the other. The "product" is a new compound that has both groups. Give it a face. Make it memorable.

**The Reaction Map Technique**
Draw a central compound (like Benzene) on a large page. Draw arrows pointing outward for each reaction it undergoes. Add the reagents on the arrows and products at the endpoints. This "reaction map" becomes your visual reference sheet.

Build separate maps for:
- Aldehydes & Ketones
- Carboxylic acids and derivatives
- Amines
- Alkenes and Alkynes

**The Three-Pass Revision System**
- **Pass 1:** Read the reaction mechanism carefully, understanding what's happening
- **Pass 2:** Re-draw the mechanism from memory with the reaction map
- **Pass 3:** Solve 10 MCQs on this specific reaction type

Doing three passes across 3 separate days (spaced repetition) locks the reaction into long-term memory.

**High-Yield Organic Reactions for NEET:**
1. Aldol condensation
2. Cannizzaro reaction
3. Kolbe reaction
4. Reimer-Tiemann reaction
5. Williamson synthesis
6. Sand meyer reaction
7. Coupling reaction (azo dye formation)
8. Fehling's and Tollens' tests

**Tip:** For named reactions, create a mnemonic using the first letters. Your brain loves patterns and hooks.

Organic Chemistry becomes enjoyable when you stop fighting it and start visualising it. Try the reaction map technique with just one reaction today.`,
        category: 'Physics & Chemistry',
        author: 'Prof. Anita Sharma',
        authorRole: 'Chemistry Mentor · Future Founder',
        date: '2025-02-18',
        readTime: '8 min read',
        image: 'https://images.unsplash.com/photo-1532094349884-543559c7d517?w=1200&h=600&fit=crop',
        tags: ['Chemistry', 'Study Plan'],
        featured: false,
        views: '9.3k',
    },
]
